import {
  FaArrowLeft,
  FaArrowRight,
  FaWhatsapp,
  FaInstagram,
  FaTiktok
} from 'react-icons/fa'; // Import the left arrow icon
import { FaXTwitter } from 'react-icons/fa6';
import { Link, useLocation } from "react-router-dom";
import { CustomersList } from './customerData.js';
import ServiceSlider from './slider.js';
import ProjectsSliders from './projectsSliders.js';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Customers from './customers.js';
import Contact from './contact.js';
import { useLanguage } from '../context/LanguageContext.js';
import { Helmet } from 'react-helmet';
import { getRoute } from "../utils/getRoute.js";

// استيراد الصور في أعلى الملف لتجنب require
import homeImgAR from '../assests/home-img-AR.jpg';
import homeImgEN from '../assests/home-img-EN.jpg';
import backAboutUs from '../assests/backAboutUs.jpg';

export default function Home() {
  const { t, language } = useLanguage();
  const CustomersDataShow = CustomersList.map((customer) => (
    <Customers key={customer.id} data={customer} />
  ));
  const location = useLocation();
  const canonicalUrl = window.location.origin + location.pathname;

  return <div className='container'>
    <Helmet>
      <title>ام بي تك - Mptech | حلول تسويقية وبرمجة متكاملة</title>
      <link rel="canonical" href={canonicalUrl} />
      <meta
        name="description"
        content="شركة Mptech تقدم حلول التسويق الإلكتروني، البرمجة، استراتيجيات التسويق الرقمي، وتطوير البرمجيات. لدينا أفضل الحلول لتسويق عبر الإنترنت وتحسين محركات البحث."
      />
      <a href="https://www.ewebdiscussion.com/forums/web-hosting-offers.67/">Hosting</a>
      <meta name="keywords"
        content="Mptech 
          mptech 
Mp tech
mp tech
mp technology
mptechnology
ام بي تك
ام بي تكنولوجي 
إم بي تك
ام بي تك للتسويق الالكتروني
نظام محاماة 
محاميين
LglTech
LglTech 
تسويق الكتروني 
تسويق رقمي 
استراتيجيات تسويق
تسويق عبر الإنترنت
تسويق عبر وسائل التواصل الاجتماعي 
تحسين محركات البحث (SEO) 
حملات إعلانات مدفوعة 
إعلانات جوجل 
تسويق المحتوى
تحليل البيانات التسويقية
برمجة مواقع الإنترنت 
برمجة تطبيقات الجوال
تطوير البرمجيات 
تطوير مواقع الإنترنت 
برمجة بلغة PHP JavaScript Python 
حلول البرمجة المخصصة 
استشارات تسويقية 
تصميم وتطوير المواقع 
تسويق برمجي 
خدمات تقنية 
وكالة تسويق رقمي 
تسويق إلكتروني
المحامي الذكي
تصميم شعار
مواقع إلكترونية
تصميم تطبيقات
مصور تغطيات إعلامية
صيانة برمجيات
حملات بريد الكتروني
مصور افنت
تصميم تطبيقات للكمبيوتر
نظام محاسبي
اي ار بي
ERP
موقع تعريفي
صناعة موقع كبير
تحسين محركات البحث
ام بي تك
شركة تسويق في جدة
شركة تقنية في جدة"
      />

      <meta name="author" content="Mptech - شركة تسويق وبرمجة" />
    </Helmet>
    <div className="container home-container" style={{ direction: language === "en" ? "ltr" : "rtl" }}>
      <div className='img-class'>
        <img src={language === "en" ? homeImgAR : homeImgEN} // استخدام المتغيرات المستوردة
          alt="My-Image" />
        <div className='home-on-img-descrition' style={{ left: language === "en" && "30%" }}>
          {language == "en" ? (
            <h2>Creating Comprehensive <span>Digital Solutions</span></h2>
          )
            :
            (<h2>ابتكار الحلول <span>الرقمية</span> المتكاملة</h2>)
          }


          <p>{t('home.home_img_description')}</p>
        </div>
        <Link to={getRoute('contact', language)}><button className='btn btn-on-img btn-on-img-contact' >{t('home.btn_contact_us_text')}{language === "ar" ? <FaArrowLeft className='arrow-icon-left' /> : <FaArrowRight className='arrow-icon-left' />}</button></Link>
        <Link to={getRoute('about', language)}><button className='btn btn-on-img btn-on-img-about'>{t('home.btn_how_are_we_text')}</button></Link>
        <div className='social-icons-home'>
          {/* WhatsApp */}
          <a
            href="https://wa.me/+966557380850" // Replace with your WhatsApp link
            target="_blank"
            rel="noopener noreferrer"

          >
            <FaWhatsapp className='social-icon' />
          </a>



          {/* Twitter */}
          <a
            href="https://x.com/mptech_sa?s=21" // Replace with your Twitter link
            target="_blank"
            rel="noopener noreferrer"

          >
            <FaXTwitter className='social-icon' />
          </a>

          {/* Instagram */}
          <a
            href="https://www.instagram.com/mptechsa" // Replace with your Instagram link
            target="_blank"
            rel="noopener noreferrer"

          >
            <FaInstagram className='social-icon' />
          </a>

          {/* Facebook */}
          {/* <a
          href="https://www.facebook.com/yourusername" // Replace with your Facebook link
          target="_blank"
          rel="noopener noreferrer"
          
        >
          <FaFacebook className='social-icon' />
        </a> */}

          {/* Telegram */}
          {/* <a
          href="https://t.me/yourusername" // Replace with your Telegram link
          target="_blank"
          rel="noopener noreferrer"
         
        >
          <FaTelegram className='social-icon' />
        </a> */}

          {/* TikTok */}
          <a
            href="https://www.tiktok.com/@mp.thech" // Replace with your TikTok link
            target="_blank"
            rel="noopener noreferrer"

          >
            <FaTiktok className='social-icon' />
          </a>
        </div>
      </div>
    </div>
    <div className='container'>
      <div className='about-container'>
        <div className='about-description'>
          <p className='section-title'>{t('home.about_section.section_title')}</p>
          <h2>{t('home.about_section.section_sub_title')}</h2>
          <p className='about-description-paragraph'>{t('home.about_section.section_description')}</p>
          <Link to={getRoute('about', language)}><button className='btn' > {t('home.about_section.btn_learn_more')}
            {language === "ar" ? <FaArrowLeft className='arrow-icon-left' /> : <FaArrowRight className='arrow-icon-left' />}
          </button></Link>
        </div>
        <div className='about-class-img'>
          <img src={backAboutUs} // استخدام المتغير المستورد
            alt="My-Image" />
          {/* <p>نجاح بابداع وتسويق مبتكر</p> */}
        </div>
      </div>
    </div>
    <div className='container'>
      <div className='service-home-container'>
        <p className='section-title'>{t('home.our_service_section.section_title')}</p>
        <h2>{t('home.our_service_section.section_sub_title')}</h2>
        <p className='about-description-paragraph'>{t('home.our_service_section.section_description')}</p>
        <div>
          <ServiceSlider /> {/* Use the slider here */}
        </div>
      </div>
    </div>
    <div className='container'>
      <p className='section-title'>{t('home.our_works_section.section_title')}</p>
      <h2>{t('home.our_works_section.section_sub_title')}</h2>
      <p className='about-description-paragraph'>{t('home.our_works_section.section_description')}</p>
      <div className="projects-container">
        <ProjectsSliders /> {/* Use the slider here */}
      </div>
    </div>
    <div className='container'>
      <p className='section-title'>{t('home.Customer_section.section_title')}</p>
      <h2>{t('home.Customer_section.section_sub_title')}</h2>
      <div className='customer-conatiner'>
        {CustomersDataShow}
      </div>
    </div>
    <div className='container'>
      <Contact />
    </div>
  </div>
}